import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import imgImportant from '../assets/newbuilds-in-page-how-we-calculate.jpg';

import translates from '../how-we-calculate-score-i18n';

const classes = new Bem('blockImportant');

@I18nHoc(translates())
export default class ImportantBlock extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { i18n } = this;
    const { className } = this.props;

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'block')} mtColumn mpColumn>
          <Col {...classes('col', 'img')} allPr={0}>
            <div {...classes('imgContainer')}>
              <img {...classes('img')} src={imgImportant} alt={i18n('blockImportantH2')} loading="lazy" decoding="async" />
            </div>
          </Col>
          <Col {...classes('col', 'info')} allPr={0}>
            <div {...classes('text', 'h2')}><h2 children={i18n('blockImportantH2')} /></div>
            <Trans lang="ru">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'squareLeft')}>
                    <p {...classes('text')} children="Мы обновляем Выписку из Реестра вещных прав, если ей больше чем 21 день от момента заказа отчёта." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'squareLeft')}>
                    <p {...classes('text')} children="ТУ на подключение к коммуникациям ─ единственные документы, которые часто невозможно получить для анализа." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'squareLeft')}>
                    <p {...classes('text')} children="В связи с невозможностью объективной оценки мы не даём и не снимаем баллы на основании информационных материалов о ЖК и застройщиках, размещённых в средствах массовой информации (СМИ) и на форумах. Мы анализируем и используем данные материалы для поиска подтверждающих документов." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'squareLeft')}>
                    <p {...classes('text')} children="Мы не анализируем деятельность фонда финансирования строительства и целевое использование средств инвесторов застройщиком, а также, возможные «двойные продажи». Такой анализ требует специальных расследований в рамках уголовных или административных производств. Современное законодательство никак не устраняет риск нецелевого использования средств инвесторов и возможность «двойных продаж»." />
                  </div>
                </li>
              </ul>
              <div {...classes('description')}>
                <p {...classes('text', 'topic')} children="Методология оценки надежности новостройки постоянно совершенствуется" />
              </div>
              <div {...classes('description')}>
                <p {...classes('text')} children="дабы обеспечивать максимальное качество и объём информации, которые могут повлиять на реализацию проекта ЖК. Здесь нам помогает открытие новых реестров, накопление данных об исторических задержках сдачи ЖК в эксплуатацию, отзывы покупателей отчётов." />
              </div>
            </Trans>
            <Trans lang="ua">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'squareLeft')}>
                    <p {...classes('text')} children="Ми оновлюємо Витяг з Реєстру речових прав, якщо йому більше ніж 21 день від моменту замовлення звіту." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'squareLeft')}>
                    <p {...classes('text')} children="ТУ на підключення до комунікацій ─ єдині документи, які буває важко або неможливо отримати для аналізу." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'squareLeft')}>
                    <p {...classes('text')} children="У зв'язку з неможливістю об'єктивної оцінки ми не даємо і не знімаємо бали на підставі інформаційних матеріалів про ЖК і забудовників, розміщених в засобах масової інформації (ЗМІ) і на форумах. Ми аналізуємо і використовуємо дані матеріали для пошуку документів з підтвердженням." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'squareLeft')}>
                    <p {...classes('text')} children="Ми не аналізуємо діяльність фонду фінансування будівництва та цільове використання коштів інвесторів забудовником, а також, можливий «подвійний продаж». Такий аналіз вимагає спеціальних розслідувань у рамках кримінальних або адміністративних проваджень. Сучасне законодавство ніяк не усуває ризик нецільового використання коштів інвесторів і можливість «подвійного продажу»." />
                  </div>
                </li>
              </ul>
              <div {...classes('description')}>
                <p {...classes('text', 'topic')} children="Методологія оцінки надійності новобудови постійно вдосконалюється" />
              </div>
              <div {...classes('description')}>
                <p {...classes('text')} children="щоб забезпечувати максимальну якість і обсяг інформації, які можуть вплинути на реалізацію проєкту ЖК. Тут нам допомагає відкриття нових реєстрів, накопичення даних про історичні затримки здачі ЖК в експлуатацію, відгуки покупців звітів." />
              </div>
            </Trans>
          </Col>
        </Row>
      </div>
    );
  }
}
